import styled from 'styled-components';
import { Link } from '@reach/router';
import { lightGrey3Color } from 'js/config/style';

export default styled(Link)`
  align-self: center;
  justify-self: center;
  color: ${lightGrey3Color};

  &:hover {
    color: black;
    text-decoration: none;
  }
`;
